// Pure logic for the corporate shipper detail page. Deterministic so it can be unit tested
// without mounting the page.

import { CONTACT_SLOTS, displayPhone, storedPhone } from '@/components/Account/ShipperAccount/contacts';
import * as ROUTES from '@/constants/routes';
import { TABS } from './constants';

export const tabIndexForSlug = (slug) => {
    const index = TABS.findIndex((t) => t.slug === slug);
    return index === -1 ? 0 : index;
};

export const slugForTabIndex = (index) => TABS[index].slug;

// The shipper as the tabs' context `client`. `circles` defaults to `{}` because useClientUser
// falls back to the admin's when it's NULL.
export const asContextClient = (shipper) =>
    shipper && { ...shipper, user: { ...shipper.user, circles: shipper.user?.circles || {} } };

/**
 * Tariff editor routes that keep the editor inside the shipper's context and return to its
 * Tariffs tab. See `useTariffRoutes`.
 * @param {string} client_id
 */
export const shipperTariffRoutes = (client_id) => ({
    editPath: (tariff_id) =>
        ROUTES.CORPORATE_SHIPPER_TARIFF.replace(':client_id', client_id).replace(':tariff_id', tariff_id),
    exitPath: `${ROUTES.corporateShipperPath(client_id)}?tab=tariffs-tags`,
});

// All three slots render, even empty, so the admin can fill in one the shipper never set.
export const contactRowsFor = (client) =>
    CONTACT_SLOTS.map((slot) => ({
        ...slot,
        name: slot.nameField ? client?.[slot.nameField] || '' : '',
        email: client?.[slot.emailField] || '',
        phone: displayPhone(client?.[slot.phoneField]),
    }));

// UPDATE_CLIENT_BY_PK patch for one contact row; only that slot's fields are written.
export const contactPatch = (slot, { name, email, phone }) => {
    const patch = {};
    if (slot.nameField) patch[slot.nameField] = name?.trim() || null;
    if (!slot.emailReadOnly) patch[slot.emailField] = email?.trim() || null;
    patch[slot.phoneField] = storedPhone(phone) || null;
    return patch;
};
